import React from 'react';

import type { CustomThemeType } from './default';
import { defaultTheme } from './default';

import type { ThemeMode } from '../../../types';

export type ThemeContextType = {
  theme: CustomThemeType;
  mode?: ThemeMode;
  toggleMode: () => void;
};

export const CustomThemeContext = React.createContext<ThemeContextType>({ theme: defaultTheme, toggleMode: () => {} });
